import { render, staticRenderFns } from "./AccountsChart.vue?vue&type=template&id=50f2ab65&"
import script from "./AccountsChart.vue?vue&type=script&lang=js&"
export * from "./AccountsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports